import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const { VUE_APP_BASE_URL: url } = process.env;
const params = { enableGuestAccess: true, rejectOn5xx: true };
const axios = createAxiosInstance(url, params);

export const fetchStylesheetResults = params => {
    return axios.get('/api/v1/style_sheet/', { params });
};

export const fetchStylesheetItem = id => {
    return axios.get(`/api/v1/style_sheet/${id}`);
};
